export let ArchiveViewerView = /*#__PURE__*/function (ArchiveViewerView) {
  ArchiveViewerView[ArchiveViewerView["MODAL"] = 0] = "MODAL";
  ArchiveViewerView[ArchiveViewerView["STATIC"] = 1] = "STATIC";
  return ArchiveViewerView;
}({});
export const createArchiveViewerData = view => ({
  view: view !== null && view !== void 0 ? view : ArchiveViewerView.STATIC,
  controlsPortal: null
});
export const createEmptyArchiveViewerData = () => ({
  view: ArchiveViewerView.STATIC,
  controlsPortal: null
});